// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__EE0fe","active":"Tab_active__5MlM9"};